module.exports = "<div id=\"detail-uf\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sketch/detail-uf/detail-uf.component.html
// module id = 53
// module chunks = 0